import axios from "axios";
import Cookies from "js-cookie";
import { create } from "zustand";
import cartStore from "./cartStore";
import addressStore from "./addressStore";
import dayjs from "dayjs";
import couponStore from "./couponStore";
import orderStore from "./orderStore";
import paymentStore from "./paymentStore";
import snackbarStore from "./snackbarStore";

const authStore = create((set) => ({
  isLogged: null,
  myUser: null,

  OTP: null,
  isOTPScreenEmail: "",
  whereNavigate: null,
  myOldPassword: null,

  signUpForm: {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNumber: "",
  },

  signInForm: { email: "", password: "" },

  editProfileForm: {
    firstName: "",
    lastName: "",
    gender: null,
    dateOfBirth: null,
  },

  signUpFormValidation: {
    isFirstName: false,
    isLastName: false,
    isEmail: false,
    emailMassage: "",
    isPhoneNumber: false,
    phoneNumberMassage: "",
    isPassword: false,
    passwordMassage: "",
  },

  setValidation: ({ name, value }) => {
    set((state) => {
      return {
        signUpFormValidation: {
          ...state.signUpFormValidation,
          [name]: value,
        },
      };
    });
  },

  fillSignUpForm: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        signUpForm: {
          ...state.signUpForm,
          [name]: value,
        },
      };
    });
  },

  fillSignInForm: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        signInForm: {
          ...state.signInForm,
          [name]: value,
        },
      };
    });
  },

  emailIsExists: async () => {
    try {
      const { signUpForm, setValidation } = authStore.getState();
      const emailExists = await axios.post("/site/user-email-is-exist", {
        email: signUpForm.email,
      });

      if (emailExists.data.status) {
        setValidation({
          name: "emailMassage",
          value: "Email address is already exists",
        });
        setValidation({ name: "isEmail", value: true });
        return false;
      } else {
        if (process.env.REACT_APP_PRODUCTION === "production") {
          const res = await axios.post("/site/send-mail-otp-verification", {
            emailTo: signUpForm.email,
          });

          set({ OTP: res.data.OTP });
        } else {
          set({ OTP: 2222 });
        }
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  emailIsExistsForSignIn: async () => {
    try {
      const { signInForm } = authStore.getState();
      const { setMassage } = snackbarStore.getState();
      const emailExists = await axios.post(
        "/site/user-email-and-password-is-exist",
        signInForm
      );

      if (emailExists.data.status) {
        if (process.env.REACT_APP_PRODUCTION === "production") {
          const res = await axios.post("/site/send-mail-otp-verification", {
            emailTo: signInForm.email,
          });
          set({ OTP: res.data.OTP });
        } else {
          set({ OTP: 2222 });
        }
        return true;
      } else {
        setMassage({ value: emailExists.data.message });
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  signUp: async () => {
    const { signUpForm, setValidation } = authStore.getState();
    try {
      const res = await axios.post("/site/sign-up", signUpForm);
      set({
        signUpForm: {
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          phoneNumber: "",
        },
      });
      if (res) {
        set({ OTP: null });
        return true;
      }
    } catch (error) {
      setValidation({
        name: "emailMassage",
        value: "Email address is already exists",
      });
      setValidation({ name: "isEmail", value: true });
      console.log(error);
    }
  },

  signIn: async () => {
    try {
      const { signInForm } = authStore.getState();
      const res = await axios.post("/site/sign-in", signInForm);

      if (res) {
        // Set the cookie
        // Cookies.set("UserAuthorization", res.data.token, {
        //   expires: new Date(res.data.exp),
        //   sameSite: "lax",
        //   secure: process.env.NODE_ENV === "production",
        //   path: "/",
        // });

        set({ isLogged: true, myUser: res.data.myUser });
        set({
          signInForm: {
            email: "",
            password: "",
          },
        });
        const { whenSignInAdd } = cartStore.getState();
        await whenSignInAdd();
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  },

  checkAuth: async () => {
    try {
      const res = await axios.get("/site/check-auth");
      set({ myUser: res.data.user });
      set({ isLogged: true });
    } catch (error) {
      set({ isLogged: false });
    }
  },

  signOut: async () => {
    await axios.get("/site/sign-out");
    set({ isLogged: false, myUser: null });
    const { setCartProductNull } = cartStore.getState();
    setCartProductNull();
    const { setMyAddressNull } = addressStore.getState();
    setMyAddressNull();
    const { setCouponNull } = couponStore.getState();
    setCouponNull();
    const { setOrderDetailsNull } = orderStore.getState();
    setOrderDetailsNull();
    const { setPaymentDetailsNull } = paymentStore.getState();
    setPaymentDetailsNull();
  },

  fillAllEditFrom: () => {
    const { myUser } = authStore.getState();
    set({
      editProfileForm: {
        firstName: myUser.firstName,
        lastName: myUser.lastName,
        gender: myUser.gender ? myUser.gender : null,
        dateOfBirth: myUser.dateOfBirth
          ? dayjs(new Date(myUser.dateOfBirth))
          : null,
      },
    });
  },

  fillEditProfileForm: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        editProfileForm: {
          ...state.editProfileForm,
          [name]: value,
        },
      };
    });
  },

  fillEditProfileFormOfBirthDate: ({ name, value }) => {
    set((state) => {
      return {
        editProfileForm: {
          ...state.editProfileForm,
          [name]: value,
        },
      };
    });
  },

  updateProfile: async () => {
    try {
      const { editProfileForm } = authStore.getState();

      const res = await axios.put("/site/update-user-profile", editProfileForm);

      set({ myUser: res.data.myUser });
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  validEmailAndSendOTP: async ({ email, whereNavigate }) => {
    try {
      const emailExists = await axios.post("/site/user-email-is-exist", {
        email,
      });

      if (emailExists.data.status) {
        if (process.env.REACT_APP_PRODUCTION === "production") {
          const res = await axios.post("/site/send-mail-otp-verification", {
            emailTo: email,
          });

          set({ OTP: res.data.OTP });
        } else {
          set({ OTP: 2222 });
        }

        if (whereNavigate === "forgot-password") {
          set({
            isOTPScreenEmail: email,
            whereNavigate,
            myOldPassword: emailExists.data.password,
          });
        } else {
          set({
            isOTPScreenEmail: email,
            whereNavigate,
          });
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  changeUserPhoneNo: async ({ phoneNumber }) => {
    try {
      const res = await axios.put("/site/change-user-phone-no", {
        phoneNumber,
      });

      set({ myUser: res.data.user });
    } catch (error) {
      console.log(error);
    }
  },

  verifyOTP: async ({ inputOTP }) => {
    const { OTP } = authStore.getState();

    if (OTP === parseInt(inputOTP)) {
      set({ OTP: null });
      return true;
    } else {
      return false;
    }
  },

  clearWhereNavigate: () => {
    set({ whereNavigate: null, isOTPScreenEmail: "", myOldPassword: null });
  },

  changeUserPassword: async ({ email, password, newPassword }) => {
    try {
      const res = await axios.put("/site/change-user-password", {
        email,
        password,
        newPassword,
      });

      return res.data;
    } catch (error) {
      console.log(error);
    }
  },

  changeForgotUserPassword: async ({ email, newPassword }) => {
    try {
      const res = await axios.put("/site/change-forgot-user-password", {
        email,
        newPassword,
      });

      return res.data;
    } catch (error) {
      console.log(error);
    }
  },
}));

export default authStore;
